
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class CircuitFlowEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
         const spacing = (150 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 2 * scale;

        const drawCircuit = (x: number, y: number, s: number) => {
             ctx.beginPath();
             ctx.moveTo(x - s/2, y);
             ctx.lineTo(x, y);
             ctx.lineTo(x, y - s/2);
             ctx.stroke();

             // Node dot
             const pulse = (Math.sin(curTime * 2 + x + y) + 1) * 0.5;
             ctx.fillStyle = pc.color;
             ctx.globalAlpha = pulse;
             ctx.beginPath();
             ctx.arc(x - s/2, y, 4 * scale, 0, Math.PI * 2);
             ctx.fill();
        };

        const draw = () => {
            for (let x = x1; x <= x2; x += spacing) {
                for (let y = y1; y <= y2; y += spacing) {
                    drawCircuit(x, y, spacing * 0.8 * scale);
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
